module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "CONTENTS",
      "src": "images/f0008-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/07introduction#page_4"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07introduction#page_4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbt"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08part01#part1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/commonyi.jpg"
    }
  })]), _c('br'), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/08part01#part1"
    }
  }, [_vm._v("Intentional Communities")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08part01#part1"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch1"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commony1.jpg"
    }
  }), _vm._v(" Libertatia")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter01#ch1"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch2"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commony2.jpg"
    }
  }), _vm._v(" The Van Dykes")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter02#ch2"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch3"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commony3.jpg"
    }
  }), _vm._v(" Freetown Christiania")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter03#ch3"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter04#ch4"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commony4.jpg"
    }
  }), _vm._v(" Auroville")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter04#ch4"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch5"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commony5.jpg"
    }
  }), _vm._v(" Oyotunji African Village")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter05#ch5"
    }
  }, [_vm._v("34")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch6"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commony6.jpg"
    }
  }), _vm._v(" Temples of Humankind")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter06#ch6"
    }
  }, [_vm._v("38")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbt"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15part02#part2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/commonrii.jpg"
    }
  })]), _c('br'), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/15part02#part2"
    }
  }, [_vm._v("Micronations")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15part02#part2"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/16chapter07#ch7"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commonr1.jpg"
    }
  }), _vm._v(" New Atlantis")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/16chapter07#ch7"
    }
  }, [_vm._v("48")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/17chapter08#ch8"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commonr2.jpg"
    }
  }), _vm._v(" Sealand")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/17chapter08#ch8"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/18chapter09#ch9"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commonr3.jpg"
    }
  }), _vm._v(" Rose Island")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/18chapter09#ch9"
    }
  }, [_vm._v("58")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/19chapter10#ch10"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commonr4.jpg"
    }
  }), _vm._v(" Principality of Hutt River")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/19chapter10#ch10"
    }
  }, [_vm._v("62")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/20chapter11#ch11"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commonr4a.jpg"
    }
  }), _vm._v(" Operation Atlantis")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/20chapter11#ch11"
    }
  }, [_vm._v("66")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/21chapter12#ch12"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commonr5.jpg"
    }
  }), _vm._v(" North Dumpling Island")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/21chapter12#ch12"
    }
  }, [_vm._v("70")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/22chapter13#ch13"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commonr6.jpg"
    }
  }), _vm._v(" Ladonia")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/22chapter13#ch13"
    }
  }, [_vm._v("72")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/23chapter14#ch14"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commonr7.jpg"
    }
  }), _vm._v(" Liberland")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/23chapter14#ch14"
    }
  }, [_vm._v("76")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/24chapter15#ch15"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commonr8.jpg"
    }
  }), _vm._v(" Gay and Lesbian Kingdom of the Coral Sea Islands")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/24chapter15#ch15"
    }
  }, [_vm._v("78")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbt"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/25part03#part3"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/commonbiii.jpg"
    }
  })]), _c('br'), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/25part03#part3"
    }
  }, [_vm._v("Failed Utopias")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/25part03#part3"
    }
  }, [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/26chapter16#ch16"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commonb1.jpg"
    }
  }), _vm._v(" Palmanova")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/26chapter16#ch16"
    }
  }, [_vm._v("86")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/27chapter17#ch17"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commonb2.jpg"
    }
  }), _vm._v(" Oneida")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/27chapter17#ch17"
    }
  }, [_vm._v("90")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/28chapter18#ch18"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commonb3.jpg"
    }
  }), _vm._v(" Tama-Re")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/28chapter18#ch18"
    }
  }, [_vm._v("94")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/29chapter19#ch19"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commonb4.jpg"
    }
  }), _vm._v(" Fordlandia")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/29chapter19#ch19"
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbt"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/30part04#part4"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/commonoiv.jpg"
    }
  })]), _c('br'), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/30part04#part4"
    }
  }, [_vm._v("Visionary Environments")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/30part04#part4"
    }
  }, [_vm._v("105")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/31chapter20#ch20"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commono1.jpg"
    }
  }), _vm._v(" Thunder Mountain Monument")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/31chapter20#ch20"
    }
  }, [_vm._v("108")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/32chapter21#ch21"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commono2.jpg"
    }
  }), _vm._v(" Yelang Valley")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/32chapter21#ch21"
    }
  }, [_vm._v("114")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/33chapter22#ch22"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commono3.jpg"
    }
  }), _vm._v(" Arizona Mystery Castle")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/33chapter22#ch22"
    }
  }, [_vm._v("118")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/34chapter23#ch23"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commono4.jpg"
    }
  }), _vm._v(" Gereja Ayam or The Chicken Church")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/34chapter23#ch23"
    }
  }, [_vm._v("122")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/35chapter24#ch24"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commono5.jpg"
    }
  }), _vm._v(" Freedom Cove")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/35chapter24#ch24"
    }
  }, [_vm._v("124")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/36chapter25#ch25"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commono6.jpg"
    }
  }), _vm._v(" Xieng Khuan and Sala Keoku")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/36chapter25#ch25"
    }
  }, [_vm._v("130")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/37chapter26#ch26"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commono7.jpg"
    }
  }), _vm._v(" Ra Paulette’s Caves")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/37chapter26#ch26"
    }
  }, [_vm._v("134")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/38chapter27#ch27"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commono8.jpg"
    }
  }), _vm._v(" Nek Chand’s Rock Garden")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/38chapter27#ch27"
    }
  }, [_vm._v("138")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbt"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/39part05#part5"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/commongv.jpg"
    }
  })]), _c('br'), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/39part05#part5"
    }
  }, [_vm._v("Strange Dreams")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/39part05#part5"
    }
  }, [_vm._v("143")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/40chapter28#ch28"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commong1.jpg"
    }
  }), _vm._v(" Metropolis")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/40chapter28#ch28"
    }
  }, [_vm._v("146")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/41chapter29#ch29"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commong2.jpg"
    }
  }), _vm._v(" Seasteading")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/41chapter29#ch29"
    }
  }, [_vm._v("152")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/42chapter30#ch30"
    }
  }, [_c('img', {
    staticClass: "image_bkg",
    attrs: {
      "alt": "image",
      "src": "images/commong3.jpg"
    }
  }), _vm._v(" Bir Tawil")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/42chapter30#ch30"
    }
  }, [_vm._v("156")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbt"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/43author#page_161"
    }
  }, [_vm._v("About the Authors")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/43author#page_161"
    }
  }, [_vm._v("161")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e494537e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06-contents02.vue
// module id = 75
// module chunks = 0